import { post } from "../../utils/Backend";
import {
  mockListMyReports,
  mockSubmitReport,
} from "./ViewpointReportMock";
import type {
  ViewpointReportListResult,
  ViewpointReportSubmitParam,
} from "./ViewpointReportTypes";

const mock = true && false;

const URL_SUBMIT =
  "/lark/app/report/submit";

const URL_LIST_MINE =
  "/lark/app/report/listMine";

export const ViewpointReportApi = {
  async submit(param: ViewpointReportSubmitParam): Promise<string> {
    if (mock) {
      return mockSubmitReport(param);
    }
    return post<ViewpointReportSubmitParam, string>(URL_SUBMIT, param);
  },

  async listMine(query: { pageNum?: number; pageSize?: number }): Promise<ViewpointReportListResult | string> {
    if (mock) {
      return mockListMyReports(query.pageNum ?? 1, query.pageSize ?? 20);
    }
    return post<{ pageNum?: number; pageSize?: number }, ViewpointReportListResult>(
      URL_LIST_MINE,
      query
    );
  },
};
